module.exports = __webpack_public_path__ + "img/00c4e39.png";